import {FC} from 'react'
import {formatSeconds} from '../../../../template/helpers/formatSeconds'

type Props = {
  data: number
}

const ErItemDuration: FC<Props> = ({data}) => {
  const count = formatSeconds(data)

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>{data === 0 ? '-' : count}</div>
    </div>
  )
}

export {ErItemDuration}
